import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { hasViewAccess } from '../../utils/api'

export const ProtectedRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      return hasViewAccess() ? <Component {...props} /> : <Redirect to={{ pathname: `/` }} />
    }}
  />
)



// WEBPACK FOOTER //
// ./src/components/Auth/ProtectedRoute.js